import Vue from "vue"
import Router from "vue-router"
import store from "@/store"

import AddFacilityPage from "../pages/AddFacilityPage"
import HelpVideosPage from "../pages/HelpVideosPage"
import HomePage from "../pages/HomePage"
import LetterBatchesPage from "../pages/monitor/LetterBatchesPage"
import ListFacilitiesPage from "../pages/ListFacilitiesPage"
import LoginPage from "../pages/LoginPage"
import LogoutPage from "../pages/LogoutPage"
import ManageCyclesPage from "../pages/ManageCyclesPage"
import CycleAuditPage from "../pages/manager/CycleAuditPage"
import MasterAuditPage from "../pages/manager/MasterAuditPage"
import ManageUsersPage from "../pages/admin/ManageUsersPage"
import NotFoundPage from "../pages/NotFoundPage"
import ProfilePage from "../pages/ProfilePage"
import SendLettersPage from "../pages/monitor/SendLettersPage"
import InsurancePolicyManagementPage from "../pages/InsurancePolicyManagementPage"
import TenantListPage from "../pages/TenantListPage"
import UnauthorizedPage from "../pages/UnauthorizedPage"
import UploadTenantsPage from "../pages/UploadTenantsPage"

Vue.use(Router)

const router = new Router({
    mode: "history",
    routes: [
        { path: "/", component: HomePage, meta: {} },
        { path: "/login", component: LoginPage, meta: { title: "Login" } },
        { path: "/logout", component: LogoutPage, meta: { title: "Logout" } },
        { path: "/unauthorized", component: UnauthorizedPage, meta: { title: "Unauthorized" } },

        {
            path: "/help-videos",
            component: HelpVideosPage,
            meta: {
                public: true,
                title: "Help Videos"
            }
        },

        { path: "/profile", component: ProfilePage, meta: { title: "Profile" } },

        { path: "/add-facility", component: AddFacilityPage, meta: { permissions_allowed: ["monitor"], title: "Add Facility" } },
        { path: "/list-facilities", component: ListFacilitiesPage, meta: { permissions_allowed: ["monitor"], title: "Facility List" } },
        { path: "/manage-cycles", component: ManageCyclesPage, meta: { permissions_allowed: ["monitor"], title: "Manage Cycles" } },
        { path: "/tenant-list", component: TenantListPage, meta: { permissions_allowed: ["monitor"], title: "Tenant List" } },
        { path: "/upload-tenants", component: UploadTenantsPage, meta: { permissions_allowed: ["monitor"], title: "Upload Tenants" } },
        { path: "/send-letters", component: SendLettersPage, meta: { permissions_allowed: ["monitor"], title: "Send Proof Letters" } },
        { path: "/insurance-policy-management", component: InsurancePolicyManagementPage, meta: { permissions_allowed: ["monitor"], title: "Insurance Policy Management" } },

        {
            path: "/letter-batches",
            component: LetterBatchesPage,
            meta: {
                permissions_allowed: ["monitor"],
                title: "Letter Batches"
            }
        },

        { path: "/master-audit", component: MasterAuditPage, meta: { permissions_allowed: ["manager"], title: "Master Audit" } },
        { path: "/cycle-audit/:cycle_id", component: CycleAuditPage, meta: { permissions_allowed: ["manager"], title: "Cycle Audit" } },

        { path: "/manage-users", component: ManageUsersPage, meta: { permissions_allowed: ["monitor"], title: "Manage Users" } },

        { path: "*", component: NotFoundPage, meta: { title: "Page Not Found" } }
    ]
})

/**
 * Redirect unauthorized users to the Unauthorized Page.
 */
router.beforeEach((to, from, next) => {
    const permissions = store.state.permissions
    const token = store.state.token

    if (to.meta.public) {
        return next()
    }

    if (to.meta.permissions_allowed) {
        if (!token || !permissions) {
            return next("/unauthorized")
        }

        // give admins full access
        if (permissions.indexOf("admin") !== -1) {
            return next()
        }

        if (!store.getters.hasPermissions(to.meta.permissions_allowed)) {
            return next("/unauthorized")
        }

        return next()
    }

    return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js